import { render, staticRenderFns } from "./ApprovalRuleDetail.vue?vue&type=template&id=71fa186e&scoped=true&"
import script from "./ApprovalRuleDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovalRuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRuleDetail.vue?vue&type=style&index=0&id=71fa186e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa186e",
  null
  
)

export default component.exports